/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TAB = "COMMENTS" | "PROFILE" | "%future added value";
export type AppContainerLocal = {
    readonly activeTab: TAB;
    readonly " $refType": "AppContainerLocal";
};
export type AppContainerLocal$data = AppContainerLocal;
export type AppContainerLocal$key = {
    readonly " $data"?: AppContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"AppContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "activeTab",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '6fe5d47b015e85bbea92ba175e9a4ab6';
export default node;
